import React from "react";
import Container from "./Container";

const StayInTheLoop = () => {
    return (
        <Container>
            <div className="font-poppins py-20">
                <h2 className="text-xl md:text-3xl lg:text-5xl uppercase tracking-wider font-bold text-[#1030f8]">
                    stay in the loop
                </h2>
                <div className="relative w-full mt-12">
                    <input
                        placeholder="Email Address"
                        className="w-full outline-none border-b border-black py-3 pr-32 text-xl md:text-2xl lg:text-3xl placeholder:tracking-wider placeholder:text-black"
                    />
                    <button
                        to="/"
                        className="font-poppins absolute top-1/2 right-0 -translate-y-1/2 text-xs mr-3 font-semibold ml-5 h-8 inline-flex items-center justify-center text-white rounded-md bg-secondary px-3 uppercase"
                    >
                        Sign up
                    </button>
                </div>
            </div>
        </Container>
    );
};

export default StayInTheLoop;
